import unboundProcessValue from "./processValue";

export default function (onlyPresent = false) {
    this.items = this.$wire.get("items");
    const data = {extended_fields: {}, bookable_groups: []};
    const form = document.getElementById("registration-form");
    const formData = new FormData(form);
    const processValue = unboundProcessValue.bind(this);

    this.items.forEach((item) => {
        if(item.hidden){
            return;
        }
        if (item.type === 'bookable-group') {
            this.getBookableGroupData(item, data, formData, '', onlyPresent);
            return;
        }
        const field = item.field;
        // AIRLST-5622: an orphaned item (its field was deleted) is not part of the submitted data.
        if (!field) {
            return;
        }
        const exists = document.querySelector(`[name="${field.form_mapping}"]`);
        if (item.type!=='multiselect' && onlyPresent && !exists) {
            return;
        }
        let value = formData.get(field.form_mapping) || null;
        // Fallback to DOM value for browsers that don't commit autofill to FormData
        if (value === null && exists && exists.value && exists.type !== 'checkbox' && exists.type !== 'radio') {
            value = exists.value
        }
        // Guest fields should be placed in root
        if (field.model !== 'guest') {
            if (!data[field.model]) {
                data[field.model] = {extended_fields: {}};
            }
            if (!field.is_extended) {
                data[field.model][field.key] = processValue(
                    item,
                    value,
                    field.form_mapping
                );
            } else {
                data[field.model]['extended_fields'][field.key] = processValue(
                    item,
                    value,
                    field.form_mapping
                );
            }
        } else {
            data['extended_fields'][field.key] = processValue(
                item,
                value,
                field.form_mapping
            );
        }

    });
    this.getCompanionData(data, formData, 'companion', onlyPresent);
    this.getCompanionData(data, formData, 'recommendation', onlyPresent);

    if (onlyPresent) {
        if (Object.keys(data.extended_fields).length === 0) {
            delete data.extended_fields;
        }
        if (data.bookable_groups.length === 0) {
            delete data.bookable_groups;
        }
    }

    return data;
}
